export default __webpack_public_path__ + "static/media/gingerbread-man.7881397e.png";